import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Attachments" */ './lazyIndex')
);

export const lazyPrefetchAllWacResources = new LazyAction(
    lazyModule,
    m => m.prefetchAllWacResources
);

export const lazyPrefetchWacResourcesForAttachments = new LazyAction(
    lazyModule,
    m => m.prefetchWacResourcesForAttachments
);

export const lazyPrefetchWacResourcesForFiles = new LazyAction(
    lazyModule,
    m => m.prefetchWacResourcesForFiles
);
